export const APP_ROUTES = {
  /** 顧客管理 */
  CUSTOMER: '/customers',
  /** お知らせ管理 */
  NOTIFICATION: '/notifications',
  /** クローラー管理 */
  CRAWLER: '/crawlers',
  /** APIキーテンプレート管理 */
  APIKEYTEMPLATE: '/apikeytemplate',
  /** リリース管理 */
  RELEASE: '/release',
  /** リリース管理-コンポーネント */
  RELEASECOMPONENT: '/release/component',
  /** リリース管理-環境 */
  RELEASEENVIRONMENT: '/release/environment',
  /** リリース管理-タスク */
  RELEASETASK: '/release/task',
  /** メニュー管理 */
  MENU_CATEGORY: '/menu-categories',
};
